import { Type, type Static } from '@sinclair/typebox';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { groupParticipantSchema } from './group-participant.schema';

export const AddParticipantResponseSchema = Type.Object({
  object: Type.Literal('ParticipantAdded'),
});

export const RemoveParticipantResponseSchema = Type.Object({
  object: Type.Literal('ParticipantRemoved'),
});

export const GetParticipantsListResponseSchema = ListResponseSchema(groupParticipantSchema);

export type AddParticipantResponse = Static<typeof AddParticipantResponseSchema>;
export type RemoveParticipantResponse = Static<typeof RemoveParticipantResponseSchema>;
export type GetParticipantsListResponse = Static<typeof GetParticipantsListResponseSchema>;
